import { isNil } from 'lodash';
import { useCallback } from 'react';
import { useWorkspaceDetails } from '@shared/scenes/workflows/hooks';
import { API } from '@shared/types/api';
import { useBuilderLink } from '@shared/util/navigation';
import { permissionSubject, useCan } from '@shared/util/permissions';

/**
 * Opens the subtable's editor in the builder, when the user can configure the card's template;
 * undefined otherwise.
 */
export function useSubtableBuilderLink(
  component: API.SubtableComponent,
  workflowTemplateId: string,
): VoidFunction | undefined {
  const subtableId = component.workflowTemplateId;
  const canConfigure = useCan('update', permissionSubject.workflowTemplate(workflowTemplateId));
  const channelSlug = useWorkspaceDetails().get(workflowTemplateId)?.baseNavigationPath;
  const navigateToBuilder = useBuilderLink(workflowTemplateId, channelSlug);
  const configureSubtable = useCallback(() => {
    navigateToBuilder({ route: '/field/subtable', subtablePath: subtableId ?? undefined });
  }, [navigateToBuilder, subtableId]);
  const canOpenBuilder = canConfigure && !isNil(channelSlug) && !isNil(subtableId);

  return canOpenBuilder ? configureSubtable : undefined;
}
